import ky from 'ky'
import {EXTERNAL_APP_BASE_PATH} from 'utils/const'

export const api = ky.create({prefixUrl: EXTERNAL_APP_BASE_PATH.primer})

export async function createSession(idToken) {
  if (!idToken) {
    return {status: 'error'}
  }

  return api
    .post('auth/session', {
      credentials: 'include',
      json: {user: {token: idToken}},
    })
    .json()
}

export async function deleteSession() {
  return api.delete('auth/session', {credentials: 'include', json: true}).json()
}
